/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_DRUG = 'GET_CURRENT_DISPLAY_OBJ_DRUG';
export const GET_PLAN_TYPE_DATA_DRUG = 'GET_PLAN_TYPE_DATA_DRUG';
export const GET_REBATE_PROGRAM_DRUG = 'GET_REBATE_PROGRAM_DRUG';
export const GET_REBATE_PROGRAM_NAME_DRUG = 'GET_REBATE_PROGRAM_NAME_DRUG';
export const GET_ERROR_MSG_DRUG = 'GET_ERROR_MSG_DRUG';
export const GET_FROM_DRUG = 'GET_FROM_DRUG';
export const SET_DISPLAY_OBJ_DRUG = 'SET_DISPLAY_OBJ_DRUG';
export const SET_REFRESH_DATA_DRUG = 'SET_REFRESH_DATA_DRUG';
export const SET_REFRESH_DATA_DRUG_DISPLAY = 'SET_REFRESH_DATA_DRUG_DISPLAY';
export const SET_SELECTED_REPORT_DRUG = 'SET_SELECTED_REPORT_DRUG';
export const SET_SUBSTANCE_DRUG_DETAIL = 'SET_SUBSTANCE_DRUG_DETAIL';
export const SET_SUBSTANCE_DRUG_SUMMARY = 'SET_SUBSTANCE_DRUG_SUMMARY';
export const SET_SUBSTANCE_DRUG_INFO = 'SET_SUBSTANCE_DRUG_INFO';
